/* External */
import { useCallback } from 'react';

/* Utils */
import { isLeftButtonMouseEvent } from '../utils/functions';

export default function useClickCallback(callback) {
  return useCallback((event) => {
    if (isLeftButtonMouseEvent(event)) {
      callback(event);
    }
  }, [callback]);
}
